(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function collectRevealTargets(root) {
    if (reduceMotion) return [];
    var scope = root || document;
    var selector = [
      'main .shopify-section > section',
      'main .shopify-section > div',
      'main .m-section',
      'main article',
      'main .m-product-card',
      'main .m-collection-card'
    ].join(',');

    return Array.prototype.slice.call(scope.querySelectorAll(selector)).filter(function (el) {
      if (el.closest('.shopify-section-header') || el.closest('.shopify-section-footer')) return false;
      if (el.classList.contains('xtreme-mi-reveal')) return false;
      return true;
    });
  }

  function initReveal(root) {
    var targets = collectRevealTargets(root);
    if (!targets.length) return;

    targets.forEach(function (el, index) {
      el.classList.add('xtreme-mi-reveal');
      el.setAttribute('data-xtreme-mi-delay', String(index % 5));
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('xtreme-mi-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('xtreme-mi-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  function initPressFeedback(root) {
    var scope = root || document;
    var selector = 'button, .m-button, a[class*="button"], .btn, [role="button"]';
    scope.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.xtremeMiBound) return;
      el.dataset.xtremeMiBound = 'true';
      el.addEventListener('pointerdown', function () { el.classList.add('xtreme-mi-pressed'); });
      ['pointerup', 'pointercancel', 'pointerleave', 'blur'].forEach(function (eventName) {
        el.addEventListener(eventName, function () { el.classList.remove('xtreme-mi-pressed'); });
      });
    });
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function initHeroMotion(root) {
    if (reduceMotion) return;
    var scope = root || document;
    var heroes = qsa(scope, [
      '.xgv2-hero',
      '.xb-hero',
      '.xg-hero',
      '.xoem-hero',
      '.xtreme-hero',
      'section[class*="hero"]'
    ].join(','));

    heroes.forEach(function (hero) {
      if (hero.dataset.xtremeMiHeroBound) return;
      hero.dataset.xtremeMiHeroBound = 'true';
      hero.classList.add('xtreme-mi-hero');

      qsa(hero, 'h1, h2, [class*="eyebrow"], [class*="subtitle"], [class*="desc"], .m-button, .btn, a[class*="button"]').forEach(function (el, index) {
        el.classList.add('xtreme-mi-hero-copy');
        el.style.transitionDelay = Math.min(index * 70, 280) + 'ms';
      });

      var media = hero.querySelector('[class*="media"], [class*="image"], picture, img');
      if (media) {
        media.classList.add('xtreme-mi-hero-media');
      }

      requestAnimationFrame(function () {
        hero.classList.add('xtreme-mi-visible');
      });
    });
  }

  function initHeroParallax() {
    if (reduceMotion || document.documentElement.dataset.xtremeMiParallaxBound) return;
    document.documentElement.dataset.xtremeMiParallaxBound = 'true';

    var ticking = false;
    function update() {
      ticking = false;
      qsa(document, '.xtreme-mi-hero').forEach(function (hero) {
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var offset = Math.max(-14, Math.min(14, rect.top * -0.025));
        hero.style.setProperty('--xtreme-mi-parallax-y', offset.toFixed(2) + 'px');
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  }

  function initProductCardEnhancements(root) {
    var scope = root || document;
    var selector = [
      '.m-product-card',
      '.m-product-list > *',
      '.xgv2-card',
      '.xb-card',
      '.xpa-card',
      '.xa-products-card',
      '[class*="product-card"]'
    ].join(',');

    qsa(scope, selector).forEach(function (card) {
      if (card.dataset.xtremeMiCardBound) return;
      if (!card.querySelector('img')) return;
      card.dataset.xtremeMiCardBound = 'true';
      card.classList.add('xtreme-mi-product-card');

      var cta = card.querySelector('.m-product-card__action, .m-product-card__quick-add, .m-product-card__buttons, .xgv2-card__actions, .xpa-card__actions, .xb-card__actions, .actions, .buttons');
      if (cta) cta.classList.add('xtreme-mi-card-cta');

      var specs = card.querySelector('.xgv2-card__specs, .xpa-card__specs, .xb-card__specs, .specs, [class*="specs"]');
      if (specs) specs.classList.add('xtreme-mi-key-specs');
    });
  }

  function bindDraggableScroller(scroller) {
    if (scroller.dataset.xtremeMiDragBound) return;
    scroller.dataset.xtremeMiDragBound = 'true';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    scroller.addEventListener('pointerdown', function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest('a, button')) return;
      isDown = true;
      moved = false;
      startX = event.clientX;
      scrollLeft = scroller.scrollLeft;
      scroller.classList.add('xtreme-mi-dragging');
      scroller.setPointerCapture && scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!isDown) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 5) moved = true;
      scroller.scrollLeft = scrollLeft - delta;
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (name) {
      scroller.addEventListener(name, function () {
        isDown = false;
        scroller.classList.remove('xtreme-mi-dragging');
      });
    });

    scroller.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
  }

  function addCarouselButtons(wrapper, track) {
    if (wrapper.querySelector('.xtreme-mi-carousel-arrow')) return;
    ['prev', 'next'].forEach(function (direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'xtreme-mi-carousel-arrow xtreme-mi-carousel-arrow--' + direction;
      button.setAttribute('aria-label', direction === 'prev' ? 'Previous products' : 'Next products');
      button.innerHTML = direction === 'prev' ? '&#8249;' : '&#8250;';
      button.addEventListener('click', function () {
        var amount = Math.max(track.clientWidth * 0.72, 280);
        track.scrollBy({ left: direction === 'prev' ? -amount : amount, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      wrapper.appendChild(button);
    });
  }

  function initFeaturedCarousels(root) {
    var scope = root || document;
    var selectors = [
      '.m-featured-collection .m-product-list',
      '[data-section-type="featured-collection"] .m-product-list',
      '.featured-products .m-product-list',
      '.xtreme-featured-products',
      '.xtreme-product-carousel'
    ];

    qsa(scope, selectors.join(',')).forEach(function (track) {
      if (track.dataset.xtremeMiCarouselBound) return;
      var cards = qsa(track, ':scope > *').filter(function (item) {
        return item.querySelector && item.querySelector('img');
      });
      if (cards.length < 4) return;

      track.dataset.xtremeMiCarouselBound = 'true';
      track.classList.add('xtreme-mi-carousel-track');
      var wrapper = track.parentElement;
      if (wrapper) {
        wrapper.classList.add('xtreme-mi-carousel');
        addCarouselButtons(wrapper, track);
      }
      bindDraggableScroller(track);
    });
  }

  function initHotspots(root) {
    var scope = root || document;
    qsa(scope, 'section[class*="application"], section[class*="scenario"], section[class*="solution"]').forEach(function (section) {
      if (section.dataset.xtremeMiHotspotsBound) return;
      var image = section.querySelector('img');
      if (!image || image.closest('.xtreme-mi-product-card')) return;
      var wrap = image.closest('a, div, figure, picture') || image.parentElement;
      if (!wrap) return;
      section.dataset.xtremeMiHotspotsBound = 'true';
      wrap.classList.add('xtreme-mi-hotspot-wrap');

      [
        { x: 32, y: 38, label: 'Application fit' },
        { x: 58, y: 52, label: 'B2B use case' },
        { x: 74, y: 34, label: 'OEM support' }
      ].forEach(function (item) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'xtreme-mi-hotspot';
        dot.style.setProperty('--xtreme-mi-hotspot-x', item.x + '%');
        dot.style.setProperty('--xtreme-mi-hotspot-y', item.y + '%');
        dot.setAttribute('aria-label', item.label);
        dot.innerHTML = '<span class="xtreme-mi-hotspot__label">' + item.label + '</span>';
        wrap.appendChild(dot);
      });
    });
  }

  function initProcessTimeline(root) {
    var scope = root || document;
    var steps = qsa(scope, [
      '.xtreme-process__step',
      '.xoem-wf .step',
      '.factory-process__card',
      '[class*="process"] article',
      '[class*="timeline"] article',
      '[class*="timeline"] .item'
    ].join(',')).filter(function (step) {
      return !step.dataset.xtremeMiProcessBound;
    });

    if (!steps.length) return;
    steps.forEach(function (step) {
      step.dataset.xtremeMiProcessBound = 'true';
      step.classList.add('xtreme-mi-process-step');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      steps.forEach(function (step) { step.classList.add('xtreme-mi-active'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('xtreme-mi-active', entry.isIntersecting);
      });
    }, { rootMargin: '-22% 0px -34% 0px', threshold: 0.28 });

    steps.forEach(function (step) { observer.observe(step); });
  }

  function initFormMicroInteractions(root) {
    var scope = root || document;
    qsa(scope, 'input:not([type="hidden"]), textarea, select').forEach(function (field) {
      if (field.dataset.xtremeMiFieldBound) return;
      field.dataset.xtremeMiFieldBound = 'true';
      field.addEventListener('focus', function () {
        var parent = field.closest('.field, .form-field, .m-contact-form__input, .m-newsletter-form__field');
        if (parent) parent.classList.add('xtreme-mi-field-active');
      });
      field.addEventListener('blur', function () {
        var parent = field.closest('.field, .form-field, .m-contact-form__input, .m-newsletter-form__field');
        if (parent) parent.classList.remove('xtreme-mi-field-active');
      });
    });
  }

  function initGamingMonitorLinks(root) {
    var scope = root || document;
    var productLinks = {
      'XT-24YB02-FHD': '/products/xtreme-xt-24yb02-24-inch-fhd-gaming-monitor-75-180hz',
      'XT-24YB02-QHD': '/products/xtreme-xt-24yb02-24-inch-qhd-gaming-monitor-75-180hz',
      'XT-24YB02-UHD': '/products/xtreme-xt-24yb02-24-inch-uhd-gaming-monitor-75-180hz',
      'XT-27YB04-FHD': '/products/xtreme-xt-27yb04-27-inch-fhd-gaming-monitor-75-180hz',
      'XT-27YB04-QHD': '/products/xtreme-xt-27yb04-27-inch-qhd-gaming-monitor-75-180hz',
      'XT-27YB04-UHD': '/products/xtreme-xt-27yb04-27-inch-uhd-gaming-monitor-75-180hz',
      'XT-32YB01-FHD': '/products/xtreme-xt-32yb01-32-inch-fhd-gaming-monitor-75-144hz',
      'XT-32YB01-QHD': '/products/xtreme-xt-32yb01-32-inch-qhd-gaming-monitor-75-144hz',
      'XT-32YB01-UHD': '/products/xtreme-xt-32yb01-32-inch-uhd-gaming-monitor-75-144hz'
    };

    qsa(scope, '[id^="xgv2-products-"] [data-card]').forEach(function (card) {
      var title = (card.querySelector('h3')?.textContent || '').trim();
      var href = productLinks[title];
      if (!href) return;

      card.dataset.cardLink = href;
      var links = qsa(card, '.buttons a');
      var specLink = links.filter(function (link) {
        return (link.textContent || '').trim() === 'ดูสเปก';
      })[0] || links[0];
      specLink = links[0];
      if (specLink) {
        specLink.setAttribute('href', href);
        if (!specLink.dataset.xtremeGamingPointerBound) {
          specLink.dataset.xtremeGamingPointerBound = 'true';
          specLink.addEventListener('pointerdown', function (event) {
            if (event.pointerType === 'mouse') {
              event.preventDefault();
              event.stopImmediatePropagation();
              window.location.href = href;
            }
          }, true);
        }
        if (!specLink.dataset.xtremeGamingLinkBound) {
          specLink.dataset.xtremeGamingLinkBound = 'true';
          specLink.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            window.location.href = href;
          }, true);
        }
      }
    });
  }

  function initProductQuoteLinks(root) {
    if (document.getElementById('rfq')) return;

    var contactUrl = '/pages/contact';
    var scope = root || document;
    qsa(scope, 'a.xtreme-inquiry-btn--quote[href="#rfq"]').forEach(function (button) {
      button.setAttribute('href', contactUrl);
    });

    if (document.documentElement.dataset.xtremeQuoteLinkBound) return;
    document.documentElement.dataset.xtremeQuoteLinkBound = 'true';
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('a.xtreme-inquiry-btn--quote[href="#rfq"]');
      if (!button || document.getElementById('rfq')) return;
      event.preventDefault();
      window.location.href = contactUrl;
    }, true);
  }

  function initMobileInquiryCta() {
    if (document.querySelector('.xtreme-mobile-inquiry-cta')) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
    if (window.Shopify && Shopify.designMode) return;

    var candidates = qsa(document, 'main a, main button').filter(function (el) {
      var text = (el.textContent || '').trim().toLowerCase();
      var href = (el.getAttribute('href') || '').toLowerCase();
      return (
        text.indexOf('inquiry') !== -1 ||
        text.indexOf('quote') !== -1 ||
        text.indexOf('contact') !== -1 ||
        text.indexOf('whatsapp') !== -1 ||
        text.indexOf('สอบถาม') !== -1 ||
        text.indexOf('เสนอราคา') !== -1 ||
        href.indexOf('whatsapp') !== -1 ||
        href.indexOf('contact') !== -1
      );
    });

    var source = candidates.filter(function (el) {
      return el.tagName.toLowerCase() === 'a' && el.getAttribute('href');
    })[0];
    if (!source) return;

    var label = (source.textContent || '').trim() || 'Send inquiry';
    var bar = document.createElement('div');
    var text = document.createElement('div');
    var link = document.createElement('a');
    bar.className = 'xtreme-mobile-inquiry-cta';
    text.className = 'xtreme-mobile-inquiry-cta__text';
    text.textContent = 'OEM monitor inquiry';
    link.className = 'xtreme-mobile-inquiry-cta__button';
    link.href = source.getAttribute('href');
    link.textContent = label;
    bar.appendChild(text);
    bar.appendChild(link);
    document.body.appendChild(bar);
    document.body.classList.add('xtreme-mi-has-mobile-cta');

    var showAt = Math.max(240, window.innerHeight * 0.45);
    function update() {
      bar.classList.toggle('xtreme-mi-visible', window.scrollY > showAt);
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init(root) {
    document.body.classList.add('xtreme-mi-ready');
    initReveal(root);
    initPressFeedback(root);
    initHeroMotion(root);
    initHeroParallax();
    initProductCardEnhancements(root);
    initFeaturedCarousels(root);
    initHotspots(root);
    initProcessTimeline(root);
    initFormMicroInteractions(root);
    initGamingMonitorLinks(root);
    initProductQuoteLinks(root);
    initMobileInquiryCta();
  }

  ready(function () {
    init(document);

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
      });
      document.addEventListener('shopify:section:reorder', function () {
        init(document);
      });
    }
  });
})();
